import { useBehavior, useTriggerAction, useUpdateWidgetValue } from '@libs/core';
import { ActionActionTypeEnum, TWidgetProps } from '@libs/types';
import { type TCoreButtonViewProps } from '@core/widgets';
import React from 'react';
import { TSelectorRegularData } from '../../../types/data';
import { TRowOption, TSelectorRegularOption } from '../../../types/options';
import { SelectorExtraView } from './SelectorExtraView';

export const SelectorExtraWidget = ({ widget }: TWidgetProps<TSelectorRegularData, TRowOption & TSelectorRegularOption>) => {
    const { updateWidgetValue } = useUpdateWidgetValue(widget);
    const { triggerActionsByType } = useTriggerAction(widget);
    const { isDisabled, isHidden } = useBehavior(widget);

    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    const handleAction = () => {
        if (widget.data?.value !== undefined) {
            updateWidgetValue(widget.data.value);
        }
        triggerActionsByType(ActionActionTypeEnum.onClick).then();
    };

    return (
        <SelectorExtraView
            widget={widget as TCoreButtonViewProps['widget']}
            uid={widget.uid}
            title={widget.data?.messages?.title}
            subtitle={widget.data?.messages?.subtitle}
            metaText={widget.data?.messages?.metaText}
            metaVariant={widget.options?.metaVariant}
            // Figma SelectorExtra: the meta text sits on text/secondary; the pill keeps the Tag default (primary).
            // Applied here, not in the shared view, so CurrencyList / ListCurrency rows keep their own defaults.
            metaHierarchy={widget.options?.metaHierarchy ?? (widget.options?.metaVariant === 'tag' ? undefined : 'secondary')}
            iconName={widget.options?.iconName}
            flagIcon={widget.options?.flagIcon}
            avatar={widget.options?.avatar}
            iconHierarchy={widget.options?.iconHierarchy}
            iconVariant={widget.options?.iconVariant}
            isSelected={widget.options?.isSelected}
            margin={widget.options?.margin}
            isDisabled={isDisabled}
            isHide={isHidden}
            handleClick={handleAction}
            parentStyleNames={parentStyleNames}
        />
    );
};
